import { makeStyles } from '@material-ui/styles';
import { MainButton } from '@bizzabo/design-system';
import cn from 'clsx';

const ItemDropdownMenuButton: React.FC<React.ComponentProps<typeof MainButton>> = ({
    children,
    className,
    ...props
}) => {
    const classes = useStyles();
    return (
        <MainButton className={cn(classes.menuButton, className)} {...props}>
            {children}
        </MainButton>
    );
};

const useStyles = makeStyles(
    theme => ({
        menuButton: {
            ...theme.typography.t81,
            height: 26,
            border: 0,
            borderRadius: 6,
            width: '100%',
            '& *': {
                textAlign: 'left',
            },
            marginTop: 4,
        },
    }),
    { classNamePrefix: 'meetings-item-dropdown-button' }
);

export default ItemDropdownMenuButton;
